import { Skeleton } from '@mui/material'

const DayCardSkeleton = () => {
  return (
    <Skeleton variant="rounded" width={170.56} height={135.19} />
  )
}

export default DayCardSkeleton